export class SchoolsForRemoveGradeLevelRequirements {

    // Server Properties
    School_ID: number;
    SchoolCode: string;
    SchoolName: string;
    GradeLevels: string;
    InUse: boolean;

    // Accessors
    get kendoSelectable(): boolean {
        return !this.InUse;
    }

    get schoolDisplay(): string {
        return (this.SchoolCode ? this.SchoolCode + '-' : '') + this.SchoolName;
    }
}